<nav>
  <ul>
    <li
      *ngFor="let item of menu"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <a routerLink="{{ item.url }}" fxLayout="row" fxLayoutAlign="start center">
        <span></span>
        <img src="{{ item.img }}" />
        {{ item.label }}
      </a>
      <div *ngIf="item.label === 'Messages' && unreadMessaages" class="chat-notification">{{ unreadMessaages }}</div>
    </li>
    <li>&nbsp;</li>
    <div class="bottom-div">
      <li routerLinkActive="active-link" [routerLinkActiveOptions]="{ exact: true }">
        <a routerLink="/reset-password" fxLayout="row" fxLayoutAlign="start center">
          <span></span>
          <img src="assets/img/sidebar-menu/settings-icon.svg" />
          Reset Password
        </a>
      </li>
      <li (click)="logout()">
        <a fxLayout="row" fxLayoutAlign="start center">
          <span></span>
          <div fxFlexOffset="20px">Sign Out</div>
        </a>
      </li>
    </div>
  </ul>
</nav>
